$(document).ready(function () {
    if ($.fn.gMap) {
        $('#map_addresses').gMap({
            address: "Breite Gasse 24, Nürnberg",
            zoom: 15,
            arrowStyle: 2,
            controls: {
                panControl: true,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: true,
                overviewMapControl: false
            },

            markers: [
                {
                    address: "Breite Gasse 24, Nürnberg",
                    popup: false
                }
            ]
        });
    }
});
